/**
 * The application entry point.
 *
 * There are no route literals here (§6.1): they live in `shell/routeTable.ts`,
 * so a feature packet adds a surface with a one-line change to a file nobody
 * else is restructuring. There is no `<Routes>` switch either — F-NAV-03 keeps
 * all four destination roots mounted, and a switch is precisely what would
 * unmount three of them.
 *
 * The port bundle is built once at module scope rather than inside the
 * component: a second bundle would mean a second visibility subscription and a
 * second leader-election participant, and neither of those announces itself
 * when it goes wrong.
 */

import { BrowserRouter } from "react-router";
import { createBrowserPorts } from "./app-state/browserPorts";
import { AppRoot } from "./shell/AppRoot";

const ports = createBrowserPorts();

export function App() {
  return (
    <BrowserRouter>
      <AppRoot ports={ports} />
    </BrowserRouter>
  );
}
